var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/users/permissions.type.ts
var RoleEnum = /* @__PURE__ */ ((RoleEnum4) => {
  RoleEnum4["VIEWER"] = "VIEWER";
  RoleEnum4["ORGANISATION_MANAGEMENT"] = "ORGANISATION_MANAGEMENT";
  RoleEnum4["USER_MANAGEMENT"] = "USER_MANAGEMENT";
  RoleEnum4["JOBS_VIEW"] = "JOBS_VIEW";
  RoleEnum4["JOB_CREATE"] = "JOB_CREATE";
  RoleEnum4["EVENTS_VIEW"] = "EVENTS_VIEW";
  RoleEnum4["EVENTS_CREATE"] = "EVENTS_CREATE";
  RoleEnum4["SUPER_ADMIN"] = "SUPER_ADMIN";
  RoleEnum4["CALL_MANAGEMENT"] = "CALL_MANAGEMENT";
  RoleEnum4["REPLAY_LITE"] = "REPLAY_LITE";
  RoleEnum4["REPLAY"] = "REPLAY";
  RoleEnum4["REPLAY_ADVANCED"] = "REPLAY_ADVANCED";
  return RoleEnum4;
})(RoleEnum || {});
var validRoles = [
  "VIEWER" /* VIEWER */,
  "ORGANISATION_MANAGEMENT" /* ORGANISATION_MANAGEMENT */,
  "USER_MANAGEMENT" /* USER_MANAGEMENT */,
  "JOBS_VIEW" /* JOBS_VIEW */,
  "JOB_CREATE" /* JOB_CREATE */,
  "EVENTS_VIEW" /* EVENTS_VIEW */,
  "EVENTS_CREATE" /* EVENTS_CREATE */,
  "SUPER_ADMIN" /* SUPER_ADMIN */,
  "REPLAY_LITE" /* REPLAY_LITE */,
  "REPLAY" /* REPLAY */,
  "REPLAY_ADVANCED" /* REPLAY_ADVANCED */
];
var RoleGroupEnum = /* @__PURE__ */ ((RoleGroupEnum4) => {
  RoleGroupEnum4["SESSION_GUEST"] = "SESSION_GUEST";
  RoleGroupEnum4["VIEWER"] = "VIEWER";
  RoleGroupEnum4["USER"] = "USER";
  RoleGroupEnum4["ADMIN"] = "ADMIN";
  return RoleGroupEnum4;
})(RoleGroupEnum || {});
var validRoleGroups = [
  "VIEWER" /* VIEWER */,
  "USER" /* USER */,
  "ADMIN" /* ADMIN */,
  "SESSION_GUEST" /* SESSION_GUEST */
];
var DefaultRoleGroupsToPermissions = {
  ["SESSION_GUEST" /* SESSION_GUEST */]: ["VIEWER" /* VIEWER */, "EVENTS_VIEW" /* EVENTS_VIEW */],
  ["ADMIN" /* ADMIN */]: [
    "USER_MANAGEMENT" /* USER_MANAGEMENT */,
    "VIEWER" /* VIEWER */,
    "CALL_MANAGEMENT" /* CALL_MANAGEMENT */,
    "EVENTS_VIEW" /* EVENTS_VIEW */,
    "REPLAY_LITE" /* REPLAY_LITE */
  ],
  ["USER" /* USER */]: [
    "JOBS_VIEW" /* JOBS_VIEW */,
    "EVENTS_VIEW" /* EVENTS_VIEW */,
    "VIEWER" /* VIEWER */,
    "CALL_MANAGEMENT" /* CALL_MANAGEMENT */,
    "REPLAY_LITE" /* REPLAY_LITE */
  ],
  ["VIEWER" /* VIEWER */]: [
    "VIEWER" /* VIEWER */,
    "REPLAY_LITE" /* REPLAY_LITE */,
    "EVENTS_VIEW" /* EVENTS_VIEW */
  ]
};
var AdditionalPermittedPermissionsByRoleGroup = {
  ["ADMIN" /* ADMIN */]: [
    "ORGANISATION_MANAGEMENT" /* ORGANISATION_MANAGEMENT */,
    "EVENTS_CREATE" /* EVENTS_CREATE */,
    "JOB_CREATE" /* JOB_CREATE */,
    "JOBS_VIEW" /* JOBS_VIEW */,
    "REPLAY" /* REPLAY */,
    "REPLAY_ADVANCED" /* REPLAY_ADVANCED */
  ],
  ["USER" /* USER */]: [
    "ORGANISATION_MANAGEMENT" /* ORGANISATION_MANAGEMENT */,
    "USER_MANAGEMENT" /* USER_MANAGEMENT */,
    "JOB_CREATE" /* JOB_CREATE */,
    "JOBS_VIEW" /* JOBS_VIEW */,
    "EVENTS_CREATE" /* EVENTS_CREATE */,
    "REPLAY_LITE" /* REPLAY_LITE */,
    "REPLAY" /* REPLAY */,
    "REPLAY_ADVANCED" /* REPLAY_ADVANCED */
  ],
  ["VIEWER" /* VIEWER */]: [
    "VIEWER" /* VIEWER */,
    "REPLAY_LITE" /* REPLAY_LITE */,
    "REPLAY" /* REPLAY */,
    "REPLAY_ADVANCED" /* REPLAY_ADVANCED */
  ],
  ["SESSION_GUEST" /* SESSION_GUEST */]: []
};

// src/access-control.ts
var CanManageTags = ["REPLAY" /* REPLAY */, "REPLAY_ADVANCED" /* REPLAY_ADVANCED */];
var CanManageEventCategories = ["ORGANISATION_MANAGEMENT" /* ORGANISATION_MANAGEMENT */];
var CanAddToPlaylist = ["REPLAY" /* REPLAY */, "REPLAY_ADVANCED" /* REPLAY_ADVANCED */];
var CanManageRoomSystems = [
  "CALL_MANAGEMENT" /* CALL_MANAGEMENT */,
  "ORGANISATION_MANAGEMENT" /* ORGANISATION_MANAGEMENT */
];
var CanViewRecordings = [
  "REPLAY" /* REPLAY */,
  "REPLAY_ADVANCED" /* REPLAY_ADVANCED */,
  "REPLAY_LITE" /* REPLAY_LITE */
];

// src/analytics/dtos.ts
import { Type } from "class-transformer";
import {
  IsDateString,
  IsNumber,
  IsOptional as IsOptional2,
  IsString,
  IsUUID,
  Min
} from "class-validator";

// src/common/helpers.ts
import {
  IsOptional,
  registerDecorator,
  ValidateIf,
  ValidatorConstraint
} from "class-validator";
import {
  addDays,
  differenceInDays,
  isBefore,
  isWeekend,
  startOfDay
} from "date-fns";

// src/sessions/session.type.ts
var SessionInvitesStatus = /* @__PURE__ */ ((SessionInvitesStatus2) => {
  SessionInvitesStatus2["ACCEPTED"] = "ACCEPTED";
  SessionInvitesStatus2["PENDING"] = "PENDING";
  SessionInvitesStatus2["REJECTED"] = "REJECTED";
  SessionInvitesStatus2["HOST"] = "HOST";
  return SessionInvitesStatus2;
})(SessionInvitesStatus || {});
var PublicSession = class {
};
var SessionPreview = class {
};
var SessionByRoomKey = class {
};
var VidyoSessionParticipant = class {
};
var SessionParticipant = class extends VidyoSessionParticipant {
};
var RecurringFrequency = /* @__PURE__ */ ((RecurringFrequency2) => {
  RecurringFrequency2["DAILY"] = "DAILY";
  RecurringFrequency2["DAILY_NOT_WEEKENDS"] = "DAILY_NOT_WEEKENDS";
  RecurringFrequency2["MONTHLY"] = "MONTHLY";
  RecurringFrequency2["WEEKLY"] = "WEEKLY";
  return RecurringFrequency2;
})(RecurringFrequency || {});
var WeekDay = /* @__PURE__ */ ((WeekDay2) => {
  WeekDay2["MONDAY"] = "MONDAY";
  WeekDay2["TUESDAY"] = "TUESDAY";
  WeekDay2["WEDNESDAY"] = "WEDNESDAY";
  WeekDay2["THURSDAY"] = "THURSDAY";
  WeekDay2["FRIDAY"] = "FRIDAY";
  WeekDay2["SATURDAY"] = "SATURDAY";
  WeekDay2["SUNDAY"] = "SUNDAY";
  return WeekDay2;
})(WeekDay || {});
var RecurringEndType = /* @__PURE__ */ ((RecurringEndType2) => {
  RecurringEndType2["DATE"] = "DATE";
  RecurringEndType2["NB_REPETITIONS"] = "NB_REPETITIONS";
  return RecurringEndType2;
})(RecurringEndType || {});
var mapRecurringFrequencyToRRule = (frequency, weeklyInterval, weeklyDays) => {
  switch (frequency) {
    case "DAILY" /* DAILY */:
      return "DAILY";
    case "DAILY_NOT_WEEKENDS" /* DAILY_NOT_WEEKENDS */:
      return "DAILY;BYDAY=MO,TU,WE,TH,FR";
    case "WEEKLY" /* WEEKLY */:
      let weeklyRule = "WEEKLY";
      if (weeklyInterval && weeklyInterval > 1) {
        weeklyRule += `;INTERVAL=${weeklyInterval}`;
      }
      if (weeklyDays && weeklyDays.length > 0) {
        const dayMap = {
          ["MONDAY" /* MONDAY */]: "MO",
          ["TUESDAY" /* TUESDAY */]: "TU",
          ["WEDNESDAY" /* WEDNESDAY */]: "WE",
          ["THURSDAY" /* THURSDAY */]: "TH",
          ["FRIDAY" /* FRIDAY */]: "FR",
          ["SATURDAY" /* SATURDAY */]: "SA",
          ["SUNDAY" /* SUNDAY */]: "SU"
        };
        const dayCodes = weeklyDays.map((day) => dayMap[day]).join(",");
        weeklyRule += `;BYDAY=${dayCodes}`;
      }
      return weeklyRule;
    case "MONTHLY" /* MONTHLY */:
      return "MONTHLY";
    default:
      throw new Error(`Unsupported frequency: ${frequency}`);
  }
};
var SESSION_FREQUENCY_MAP = {
  /** 1 day in milliseconds */
  ["DAILY" /* DAILY */]: 24 * 60 * 60 * 1e3,
  /** 1 day, skipping weekends handled separately */
  ["DAILY_NOT_WEEKENDS" /* DAILY_NOT_WEEKENDS */]: 24 * 60 * 60 * 1e3,
  /** Monthly handled with addMonths */
  ["MONTHLY" /* MONTHLY */]: 0,
  /** 7 days in milliseconds */
  ["WEEKLY" /* WEEKLY */]: 7 * 24 * 60 * 60 * 1e3
};
var PublicBreakoutSession = class {
};
var PublicSessionWithHostOrganisation = class extends PublicSession {
};

// src/common/helpers.ts
function IsOptionalNonNullable(data) {
  const { nullable = false, validationOptions = void 0 } = data || {};
  if (nullable) {
    return IsOptional(validationOptions);
  }
  return ValidateIf((ob, v) => {
    return v !== void 0;
  }, validationOptions);
}
var IsEmailArrayConstraint = class {
  validate(emails, args) {
    if (!Array.isArray(emails)) return false;
    return emails.every(
      (email) => typeof email === "string" && /\S+@\S+\.\S+/.test(email)
    );
  }
  defaultMessage(args) {
    return "Each element in guests must be a valid email address.";
  }
};
IsEmailArrayConstraint = __decorateClass([
  ValidatorConstraint({ name: "IsEmailArray", async: false })
], IsEmailArrayConstraint);
var IsBeforeConstraint = class {
  validate(propertyValue, args) {
    const object = args.object;
    const relatedValue = object[args.constraints[0]];
    if (!relatedValue || !propertyValue) {
      return true;
    }
    const dateA = new Date(propertyValue);
    const dateB = new Date(relatedValue);
    if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
      return false;
    }
    return dateA < dateB;
  }
  defaultMessage(args) {
    return `${args.property} must be before ${args.constraints[0]}`;
  }
};
IsBeforeConstraint = __decorateClass([
  ValidatorConstraint({ name: "isBefore", async: false })
], IsBeforeConstraint);
function IsBefore(property, validationOptions) {
  return function(object, propertyName) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [property],
      validator: IsBeforeConstraint
    });
  };
}
var WithPagination = class {
};
function isCreateSessionDto(object) {
  return object && typeof object.start === "string" && object.recurringFrequency !== void 0;
}
function IsValidRecurrenceRange(validationOptions) {
  return function(object, propertyName) {
    registerDecorator({
      name: "isValidRecurrenceRange",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value, args) {
          if (!isCreateSessionDto(args.object)) {
            return false;
          }
          const { recurringFrequency, start: startDate } = args.object;
          if (!recurringFrequency || !value || !startDate) return true;
          const start = new Date(startDate);
          const diffInDays = differenceInDays(value, start);
          switch (recurringFrequency) {
            case "MONTHLY" /* MONTHLY */:
              return diffInDays >= 30;
            case "WEEKLY" /* WEEKLY */:
              return diffInDays >= 7;
            case "DAILY" /* DAILY */:
              return diffInDays >= 1;
            case "DAILY_NOT_WEEKENDS" /* DAILY_NOT_WEEKENDS */:
              let currentDay = startOfDay(new Date(start));
              let daysPassed = 0;
              const normalizedValue = startOfDay(new Date(value));
              while (isBefore(currentDay, normalizedValue)) {
                currentDay = addDays(currentDay, 1);
                if (!isWeekend(currentDay)) {
                  daysPassed++;
                }
              }
              return daysPassed >= 1;
            default:
              return true;
          }
        },
        defaultMessage(args) {
          if (!isCreateSessionDto(args.object)) {
            return "Invalid recurrence range";
          }
          const { recurringFrequency } = args.object;
          switch (recurringFrequency) {
            case "MONTHLY" /* MONTHLY */:
              return "The time range is too short for a monthly recurrence (at least 30 days).";
            case "WEEKLY" /* WEEKLY */:
              return "The time range is too short for a weekly recurrence (at least 7 days).";
            case "DAILY" /* DAILY */:
              return "The time range is too short for a daily recurrence (at least 1 day).";
            default:
              return "Invalid recurrence range.";
          }
        }
      }
    });
  };
}
var IsStringNotEmptyConstraint = class {
  validate(value, args) {
    if (value === void 0 || value === null) {
      return false;
    }
    return typeof value === "string" && value.trim().length > 0;
  }
  defaultMessage(args) {
    return `${args.property} must be a non-empty string`;
  }
};
IsStringNotEmptyConstraint = __decorateClass([
  ValidatorConstraint({ name: "isStringNotEmpty", async: false })
], IsStringNotEmptyConstraint);
function IsStringNotEmpty(validationOptions) {
  return function(object, propertyName) {
    registerDecorator({
      name: "isStringNotEmpty",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: IsStringNotEmptyConstraint
    });
  };
}
function IsDateAfter(property, validationOptions) {
  return function(object, propertyName) {
    registerDecorator({
      name: "isDateAfter",
      target: object.constructor,
      propertyName,
      constraints: [property],
      options: validationOptions,
      validator: {
        validate(value, args) {
          const [relatedPropertyName] = args.constraints;
          const relatedValue = args.object[relatedPropertyName];
          return value instanceof Date && relatedValue instanceof Date && value > relatedValue;
        }
      }
    });
  };
}

// src/analytics/dtos.ts
var GetBaseAnalyticsDto = class {
};
__decorateClass([
  IsUUID(),
  IsOptionalNonNullable()
], GetBaseAnalyticsDto.prototype, "organisationId", 2);
__decorateClass([
  IsUUID(),
  IsOptionalNonNullable()
], GetBaseAnalyticsDto.prototype, "roomSystemId", 2);
var GetAnalyticsDto = class {
};
__decorateClass([
  IsDateString()
], GetAnalyticsDto.prototype, "from", 2);
__decorateClass([
  IsDateString()
], GetAnalyticsDto.prototype, "to", 2);
__decorateClass([
  IsUUID(),
  IsOptionalNonNullable()
], GetAnalyticsDto.prototype, "organisationId", 2);
__decorateClass([
  IsUUID(),
  IsOptionalNonNullable()
], GetAnalyticsDto.prototype, "roomSystemId", 2);
__decorateClass([
  IsOptional2(),
  Type(() => Number),
  IsNumber(),
  Min(1)
], GetAnalyticsDto.prototype, "limit", 2);
__decorateClass([
  IsOptional2(),
  Type(() => Number),
  IsNumber(),
  Min(0)
], GetAnalyticsDto.prototype, "offset", 2);
var RecordUserDailyVisitsDto = class {
};
__decorateClass([
  IsUUID()
], RecordUserDailyVisitsDto.prototype, "organisationId", 2);
__decorateClass([
  IsString()
], RecordUserDailyVisitsDto.prototype, "userId", 2);
var GetReplayBaseAnalyticsDto = class {
};
__decorateClass([
  IsUUID(),
  IsOptionalNonNullable()
], GetReplayBaseAnalyticsDto.prototype, "organisationId", 2);
var TrackRecordingViewDto = class {
};
__decorateClass([
  IsUUID()
], TrackRecordingViewDto.prototype, "recordingId", 2);
__decorateClass([
  IsUUID()
], TrackRecordingViewDto.prototype, "userId", 2);
__decorateClass([
  IsUUID()
], TrackRecordingViewDto.prototype, "organisationId", 2);
__decorateClass([
  IsNumber()
], TrackRecordingViewDto.prototype, "viewDurationSeconds", 2);
__decorateClass([
  IsNumber()
], TrackRecordingViewDto.prototype, "startPositionSeconds", 2);
__decorateClass([
  IsNumber()
], TrackRecordingViewDto.prototype, "endPositionSeconds", 2);

// src/announcements/announcements.type.ts
import {
  IsArray,
  IsBoolean,
  IsDateString as IsDateString2,
  IsEnum,
  IsNotEmpty,
  IsString as IsString2,
  IsUUID as IsUUID2,
  MaxLength,
  Validate
} from "class-validator";
var AnnouncementType = /* @__PURE__ */ ((AnnouncementType2) => {
  AnnouncementType2["NOTICE"] = "NOTICE";
  AnnouncementType2["URGENT"] = "URGENT";
  AnnouncementType2["WARNING"] = "WARNING";
  AnnouncementType2["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  return AnnouncementType2;
})(AnnouncementType || {});
var CreateAnnouncementDto = class {
};
__decorateClass([
  IsEnum(AnnouncementType),
  IsNotEmpty()
], CreateAnnouncementDto.prototype, "type", 2);
__decorateClass([
  IsString2(),
  IsNotEmpty(),
  MaxLength(500, { message: "Title must not exceed 500 characters" })
], CreateAnnouncementDto.prototype, "title", 2);
__decorateClass([
  IsString2(),
  IsNotEmpty(),
  MaxLength(2e3, { message: "Message must not exceed 2000 characters" })
], CreateAnnouncementDto.prototype, "message", 2);
__decorateClass([
  IsDateString2(),
  IsNotEmpty(),
  Validate(IsBeforeConstraint, ["endDate"])
], CreateAnnouncementDto.prototype, "startDate", 2);
__decorateClass([
  IsDateString2(),
  IsNotEmpty()
], CreateAnnouncementDto.prototype, "endDate", 2);
__decorateClass([
  IsBoolean()
], CreateAnnouncementDto.prototype, "isGlobal", 2);
__decorateClass([
  IsArray(),
  IsOptionalNonNullable(),
  IsUUID2("4", { each: true })
], CreateAnnouncementDto.prototype, "organisationIds", 2);
var UpdateAnnouncementDto = class {
};
__decorateClass([
  IsEnum(AnnouncementType),
  IsNotEmpty(),
  IsOptionalNonNullable()
], UpdateAnnouncementDto.prototype, "type", 2);
__decorateClass([
  IsString2(),
  IsNotEmpty(),
  MaxLength(500, { message: "Title must not exceed 500 characters" }),
  IsOptionalNonNullable()
], UpdateAnnouncementDto.prototype, "title", 2);
__decorateClass([
  IsString2(),
  IsNotEmpty(),
  MaxLength(2e3, { message: "Message must not exceed 2000 characters" }),
  IsOptionalNonNullable()
], UpdateAnnouncementDto.prototype, "message", 2);
__decorateClass([
  IsDateString2(),
  IsNotEmpty(),
  IsOptionalNonNullable(),
  Validate(IsBeforeConstraint, ["endDate"])
], UpdateAnnouncementDto.prototype, "startDate", 2);
__decorateClass([
  IsDateString2(),
  IsNotEmpty(),
  IsOptionalNonNullable()
], UpdateAnnouncementDto.prototype, "endDate", 2);
__decorateClass([
  IsBoolean(),
  IsOptionalNonNullable()
], UpdateAnnouncementDto.prototype, "isGlobal", 2);
__decorateClass([
  IsArray(),
  IsOptionalNonNullable(),
  IsUUID2("4", { each: true })
], UpdateAnnouncementDto.prototype, "organisationIds", 2);

// src/common/environments.ts
var Environments = /* @__PURE__ */ ((Environments2) => {
  Environments2["development"] = "development";
  Environments2["staging"] = "staging";
  Environments2["production"] = "production";
  Environments2["test"] = "test";
  return Environments2;
})(Environments || {});

// src/emails/is-associated-email-payload.ts
import {
  registerDecorator as registerDecorator2,
  validate,
  ValidatorConstraint as ValidatorConstraint2
} from "class-validator";
import { plainToInstance } from "class-transformer";

// src/emails/send-email.dto.ts
import { Type as Type2 } from "class-transformer";
import {
  ArrayMinSize,
  IsArray as IsArray2,
  IsDefined,
  IsEmail,
  IsEnum as IsEnum3,
  IsInt,
  IsOptional as IsOptional3,
  IsString as IsString4,
  Min as Min2,
  ValidateNested
} from "class-validator";

// src/emails/payloads/payloads.ts
import { IsBoolean as IsBoolean2, IsEnum as IsEnum2, IsString as IsString3, IsUrl, IsUUID as IsUUID3 } from "class-validator";
var DefaultEmailPayload = class {
};
__decorateClass([
  IsString3()
], DefaultEmailPayload.prototype, "organisation", 2);
__decorateClass([
  IsUrl()
], DefaultEmailPayload.prototype, "supportPage", 2);
var RawEmailPayload = class {
};
__decorateClass([
  IsString3()
], RawEmailPayload.prototype, "subject", 2);
__decorateClass([
  IsStringNotEmpty()
], RawEmailPayload.prototype, "html", 2);
var FeedbackRatings = ["Good", "Bad", "Ok", "Great"];
var SubmitFeedbackDto = class {
};
__decorateClass([
  IsEnum2(FeedbackRatings),
  IsOptionalNonNullable()
], SubmitFeedbackDto.prototype, "rating", 2);
__decorateClass([
  IsBoolean2()
], SubmitFeedbackDto.prototype, "isUserHappyToBeContacted", 2);
__decorateClass([
  IsString3(),
  IsOptionalNonNullable()
], SubmitFeedbackDto.prototype, "description", 2);
var SubmitEventInterestDto = class {
};
__decorateClass([
  IsUUID3()
], SubmitEventInterestDto.prototype, "eventId", 2);
__decorateClass([
  IsUUID3()
], SubmitEventInterestDto.prototype, "orgId", 2);

// src/emails/send-email.dto.ts
var EmailTemplateEnum = /* @__PURE__ */ ((EmailTemplateEnum3) => {
  EmailTemplateEnum3["RawEmail"] = "RawEmail";
  return EmailTemplateEnum3;
})(EmailTemplateEnum || {});
var emailTemplateIdsToPayloads = {
  ["RawEmail" /* RawEmail */]: RawEmailPayload
};
var EmailPayload = class {
};
__decorateClass([
  IsEmail()
], EmailPayload.prototype, "toEmail", 2);
__decorateClass([
  IsDefined()
], EmailPayload.prototype, "payload", 2);
var EmailTemplatesToNames = {
  ["RawEmail" /* RawEmail */]: "Raw Email"
};
var Attachment = class {
};
__decorateClass([
  IsString4({ each: true })
], Attachment.prototype, "header", 2);
__decorateClass([
  IsString4()
], Attachment.prototype, "body", 2);
var SendEmailDto = class {
};
__decorateClass([
  IsEnum3(EmailTemplateEnum)
], SendEmailDto.prototype, "template", 2);
__decorateClass([
  IsArray2(),
  ArrayMinSize(1)
], SendEmailDto.prototype, "payload", 2);
__decorateClass([
  IsOptional3(),
  IsInt(),
  Min2(1)
], SendEmailDto.prototype, "numOfRetries", 2);
__decorateClass([
  IsArray2(),
  Type2(() => Attachment),
  ValidateNested(),
  IsOptionalNonNullable()
], SendEmailDto.prototype, "attachments", 2);

// src/emails/is-associated-email-payload.ts
var IsAssociatedEmailPayloadConstraint = class {
  constructor() {
    this.errorMessages = [];
  }
  validate(emails, args) {
    return __async(this, null, function* () {
      const template = args.object.template;
      if (!template) {
        this.errorMessages.push("Email template not provided");
        return false;
      }
      const TemplateValidationDto = emailTemplateIdsToPayloads[template];
      if (!TemplateValidationDto) {
        this.errorMessages.push("Email template validation cannot be executed");
        return false;
      }
      const emailsArray = Object.entries(emails);
      const errors = [];
      for (const [, email] of emailsArray) {
        const dto = plainToInstance(TemplateValidationDto, email.payload);
        const validationResult = yield validate(dto);
        errors.push(...validationResult);
      }
      if (errors.length > 0) {
        this.errorMessages = errors.map((error) => Object.values(error.constraints || {}).join(", ")).filter((msg) => msg);
        return false;
      }
      return true;
    });
  }
  defaultMessage() {
    var _a;
    const isInvalid = this.errorMessages.length > 0;
    return isInvalid ? (_a = this.errorMessages) == null ? void 0 : _a.join(" ; ") : "Invalid e-mail payload";
  }
};
IsAssociatedEmailPayloadConstraint = __decorateClass([
  ValidatorConstraint2({ async: true })
], IsAssociatedEmailPayloadConstraint);
function IsAssociatedEmailPayload(validationOptions) {
  return function(object, propertyName) {
    registerDecorator2({
      name: "IsAssociatedEmailPayload",
      target: object.constructor,
      propertyName,
      constraints: [],
      options: validationOptions,
      validator: IsAssociatedEmailPayloadConstraint,
      async: true
    });
  };
}

// src/event-categories/dto.ts
import { IsString as IsString5 } from "class-validator";
var CreateEventCategoryDto = class {
};
__decorateClass([
  IsString5()
], CreateEventCategoryDto.prototype, "name", 2);

// src/events/dtos.ts
import { Transform, Type as Type3 } from "class-transformer";
import {
  ArrayMinSize as ArrayMinSize2,
  IsArray as IsArray3,
  IsBoolean as IsBoolean3,
  IsDateString as IsDateString3,
  IsEnum as IsEnum4,
  IsInt as IsInt2,
  IsNumber as IsNumber2,
  IsOptional as IsOptional4,
  IsString as IsString6,
  IsUUID as IsUUID4,
  Matches,
  Min as Min3,
  Validate as Validate2,
  ValidateIf as ValidateIf2,
  ValidateNested as ValidateNested2
} from "class-validator";

// src/events/events.type.ts
var EventCategory = /* @__PURE__ */ ((EventCategory2) => {
  EventCategory2["MARKETING"] = "MARKETING";
  EventCategory2["SALES"] = "SALES";
  EventCategory2["ENGINEERING"] = "ENGINEERING";
  return EventCategory2;
})(EventCategory || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["WORKSHOP"] = "WORKSHOP";
  EventType2["PRESENTATION"] = "PRESENTATION";
  EventType2["LECTURE"] = "LECTURE";
  return EventType2;
})(EventType || {});
var EventStatus = /* @__PURE__ */ ((EventStatus2) => {
  EventStatus2["ACTIVE"] = "ACTIVE";
  EventStatus2["CANCELLED"] = "CANCELLED";
  return EventStatus2;
})(EventStatus || {});
var EventVisibility = /* @__PURE__ */ ((EventVisibility2) => {
  EventVisibility2["PRIVATE"] = "PRIVATE";
  EventVisibility2["ORGANISATION_WIDE"] = "ORGANISATION_WIDE";
  EventVisibility2["PUBLIC"] = "PUBLIC";
  return EventVisibility2;
})(EventVisibility || {});

// src/events/dtos.ts
var SessionDto = class {
};
__decorateClass([
  IsDateString3(),
  IsStringNotEmpty()
], SessionDto.prototype, "start", 2);
__decorateClass([
  IsDateString3(),
  IsStringNotEmpty()
], SessionDto.prototype, "end", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty()
], SessionDto.prototype, "name", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty()
], SessionDto.prototype, "description", 2);
__decorateClass([
  IsBoolean3()
], SessionDto.prototype, "isScheduledToRecord", 2);
__decorateClass([
  IsBoolean3()
], SessionDto.prototype, "isClosedCaptionsEnabled", 2);
__decorateClass([
  IsBoolean3()
], SessionDto.prototype, "isParticipantScreenSharing", 2);
__decorateClass([
  IsBoolean3()
], SessionDto.prototype, "isRaisedHandSoundEnabled", 2);
__decorateClass([
  IsBoolean3()
], SessionDto.prototype, "isChatEnabled", 2);
var UpdateEventSessionDto = class {
};
__decorateClass([
  IsDateString3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "start", 2);
__decorateClass([
  IsDateString3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "end", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "name", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "description", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "isScheduledToRecord", 2);
__decorateClass([
  IsArray3(),
  IsUUID4(void 0, { each: true }),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "roomSystemIds", 2);
__decorateClass([
  IsArray3(),
  Validate2(IsEmailArrayConstraint),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "guests", 2);
__decorateClass([
  IsArray3(),
  IsString6({ each: true }),
  Matches(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, {
    each: true
  }),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "moderatorIds", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "isClosedCaptionsEnabled", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "isParticipantScreenSharing", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "isRaisedHandSoundEnabled", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventSessionDto.prototype, "isChatEnabled", 2);
var CreateEventDto = class {
};
__decorateClass([
  IsString6(),
  IsStringNotEmpty()
], CreateEventDto.prototype, "bannerS3Path", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty()
], CreateEventDto.prototype, "category", 2);
__decorateClass([
  IsEnum4(EventType)
], CreateEventDto.prototype, "type", 2);
__decorateClass([
  IsEnum4(EventVisibility)
], CreateEventDto.prototype, "visibility", 2);
__decorateClass([
  IsBoolean3()
], CreateEventDto.prototype, "isCapacityCapped", 2);
__decorateClass([
  ValidateIf2((o) => o.isCapacityCapped),
  IsInt2(),
  Min3(1)
], CreateEventDto.prototype, "capacityLimit", 2);
__decorateClass([
  IsBoolean3()
], CreateEventDto.prototype, "isApprovalRequired", 2);
__decorateClass([
  IsBoolean3()
], CreateEventDto.prototype, "isFree", 2);
__decorateClass([
  ValidateIf2((o) => !o.isFree),
  IsNumber2(),
  Min3(1)
], CreateEventDto.prototype, "cost", 2);
__decorateClass([
  ValidateNested2(),
  Type3(() => SessionDto)
], CreateEventDto.prototype, "session", 2);
var UpdateEventDto = class {
};
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "bannerS3Path", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "category", 2);
__decorateClass([
  IsEnum4(EventType),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "type", 2);
__decorateClass([
  IsEnum4(EventVisibility),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "visibility", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "isCapacityCapped", 2);
__decorateClass([
  IsInt2(),
  Min3(1),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "capacityLimit", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "isApprovalRequired", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "isFree", 2);
__decorateClass([
  IsNumber2(),
  Min3(0),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "cost", 2);
__decorateClass([
  ValidateNested2(),
  Type3(() => UpdateEventSessionDto),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "session", 2);
__decorateClass([
  IsUUID4(),
  IsOptional4()
], UpdateEventDto.prototype, "hostRoomSystemId", 2);
__decorateClass([
  IsBoolean3(),
  IsOptionalNonNullable()
], UpdateEventDto.prototype, "shouldSendRemovalEmails", 2);
var AddEventParticipantsParamsDto = class {
};
__decorateClass([
  IsUUID4()
], AddEventParticipantsParamsDto.prototype, "eventId", 2);
__decorateClass([
  IsUUID4()
], AddEventParticipantsParamsDto.prototype, "orgId", 2);
var AddEventParticipantsDto = class {
};
__decorateClass([
  ArrayMinSize2(1),
  IsArray3(),
  ValidateNested2({ each: true }),
  Type3(() => AddEventParticipantDto),
  IsOptionalNonNullable()
], AddEventParticipantsDto.prototype, "participants", 2);
var AddEventParticipantDto = class {
};
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  ValidateIf2((o) => !o.roomSystemId)
], AddEventParticipantDto.prototype, "userId", 2);
__decorateClass([
  IsString6(),
  IsStringNotEmpty(),
  ValidateIf2((o) => !o.userId)
], AddEventParticipantDto.prototype, "roomSystemId", 2);
var GetEventsDto = class {
};
__decorateClass([
  IsOptional4(),
  Type3(() => Number),
  IsInt2(),
  Min3(1)
], GetEventsDto.prototype, "limit", 2);
__decorateClass([
  IsOptional4(),
  Type3(() => Number),
  IsInt2(),
  Min3(0)
], GetEventsDto.prototype, "offset", 2);
__decorateClass([
  IsOptional4(),
  IsString6()
], GetEventsDto.prototype, "search", 2);
__decorateClass([
  IsOptional4(),
  IsString6()
], GetEventsDto.prototype, "category", 2);
__decorateClass([
  IsOptional4(),
  IsDateString3()
], GetEventsDto.prototype, "startDate", 2);
__decorateClass([
  IsOptional4(),
  IsDateString3()
], GetEventsDto.prototype, "endDate", 2);
__decorateClass([
  IsOptional4(),
  IsEnum4(EventType)
], GetEventsDto.prototype, "type", 2);
__decorateClass([
  IsOptional4(),
  IsBoolean3(),
  Transform(({ value }) => value === "true")
], GetEventsDto.prototype, "isAttending", 2);
var AddOrganisationToEventDto = class {
};
__decorateClass([
  IsUUID4(),
  IsStringNotEmpty()
], AddOrganisationToEventDto.prototype, "organisationId", 2);

// src/hello/hello.ts
var HelloType = /* @__PURE__ */ ((HelloType2) => {
  HelloType2["Message"] = "message";
  HelloType2["Riddle"] = "riddle";
  HelloType2["FunFact"] = "funfact";
  return HelloType2;
})(HelloType || {});

// src/invitations/dtos.ts
import {
  ArrayMinSize as ArrayMinSize3,
  ArrayNotEmpty,
  IsArray as IsArray4,
  IsDefined as IsDefined2,
  IsEmail as IsEmail2,
  IsIn
} from "class-validator";
var CreateInvitationsDto = class {
};
__decorateClass([
  IsArray4(),
  ArrayNotEmpty(),
  IsEmail2(void 0, { each: true })
], CreateInvitationsDto.prototype, "emails", 2);
__decorateClass([
  IsDefined2(),
  IsIn(validRoleGroups)
], CreateInvitationsDto.prototype, "roleGroup", 2);
__decorateClass([
  IsArray4(),
  IsDefined2(),
  ArrayMinSize3(1),
  IsIn(validRoles, { each: true }),
  IsOptionalNonNullable()
], CreateInvitationsDto.prototype, "additionalRoles", 2);

// src/invitations/invitation.type.ts
var InviteStatusEnum = /* @__PURE__ */ ((InviteStatusEnum2) => {
  InviteStatusEnum2["PENDING"] = "PENDING";
  InviteStatusEnum2["ACCEPTED"] = "ACCEPTED";
  InviteStatusEnum2["EXPIRED"] = "EXPIRED";
  return InviteStatusEnum2;
})(InviteStatusEnum || {});
var PublicInvitation = class {
};

// src/licensing/dtos.ts
import { Type as Type5 } from "class-transformer";
import { IsDateString as IsDateString5, IsEnum as IsEnum7, IsUUID as IsUUID6, ValidateNested as ValidateNested4 } from "class-validator";

// src/organisations/dtos.ts
import { Type as Type4 } from "class-transformer";
import {
  IsBoolean as IsBoolean5,
  IsDateString as IsDateString4,
  IsEnum as IsEnum6,
  IsInt as IsInt4,
  IsMobilePhone,
  IsOptional as IsOptional5,
  IsPositive as IsPositive2,
  IsString as IsString7,
  IsUrl as IsUrl2,
  IsUUID as IsUUID5,
  Min as Min5,
  ValidateNested as ValidateNested3
} from "class-validator";

// src/licensing/licensing.type.ts
import { IsBoolean as IsBoolean4, IsEnum as IsEnum5, IsInt as IsInt3, IsPositive, Min as Min4 } from "class-validator";
var LicensingNameEnum = /* @__PURE__ */ ((LicensingNameEnum2) => {
  LicensingNameEnum2["ESSENTIALS"] = "ESSENTIALS";
  LicensingNameEnum2["ADVANCED"] = "ADVANCED";
  LicensingNameEnum2["PREMIUM"] = "PREMIUM";
  return LicensingNameEnum2;
})(LicensingNameEnum || {});
var ReplayTypeEnum = /* @__PURE__ */ ((ReplayTypeEnum2) => {
  ReplayTypeEnum2["LITE"] = "LITE";
  ReplayTypeEnum2["REPLAY"] = "REPLAY";
  ReplayTypeEnum2["ADVANCED"] = "ADVANCED";
  return ReplayTypeEnum2;
})(ReplayTypeEnum || {});
var SupportLevelEnum = /* @__PURE__ */ ((SupportLevelEnum2) => {
  SupportLevelEnum2["STANDARD"] = "STANDARD";
  SupportLevelEnum2["ENHANCED"] = "ENHANCED";
  SupportLevelEnum2["PREMIUM"] = "PREMIUM";
  return SupportLevelEnum2;
})(SupportLevelEnum || {});
var TrialFeature = /* @__PURE__ */ ((TrialFeature2) => {
  TrialFeature2["EVENTS"] = "EVENTS";
  TrialFeature2["MARKETPLACE"] = "MARKETPLACE";
  TrialFeature2["REPLAY"] = "REPLAY";
  return TrialFeature2;
})(TrialFeature || {});
var CreateLicenseDto = class {
};
__decorateClass([
  IsEnum5(LicensingNameEnum)
], CreateLicenseDto.prototype, "name", 2);
__decorateClass([
  IsInt3(),
  IsPositive()
], CreateLicenseDto.prototype, "concurrency", 2);
__decorateClass([
  IsEnum5(ReplayTypeEnum)
], CreateLicenseDto.prototype, "replay", 2);
__decorateClass([
  IsBoolean4()
], CreateLicenseDto.prototype, "isGivenEventAccess", 2);
__decorateClass([
  IsBoolean4()
], CreateLicenseDto.prototype, "isGivenMarketplaceAccess", 2);
__decorateClass([
  IsInt3(),
  Min4(0)
], CreateLicenseDto.prototype, "storageInGB", 2);
__decorateClass([
  IsEnum5(SupportLevelEnum)
], CreateLicenseDto.prototype, "supportLevel", 2);
__decorateClass([
  IsInt3(),
  IsPositive(),
  Min4(1)
], CreateLicenseDto.prototype, "storageDurationInDays", 2);
var PublicLicense = class {
};
var PublicOrganisationLicense = class {
};

// src/organisations/organisations.type.ts
var PublicOrganisation = class {
};
var ReplayCommentStatus = /* @__PURE__ */ ((ReplayCommentStatus2) => {
  ReplayCommentStatus2["ALL"] = "ALL";
  ReplayCommentStatus2["ONLY_ADMINS"] = "ONLY_ADMINS";
  ReplayCommentStatus2["NONE"] = "NONE";
  return ReplayCommentStatus2;
})(ReplayCommentStatus || {});

// src/organisations/dtos.ts
var LicenseOverridesDto = class {
};
__decorateClass([
  IsInt4(),
  IsPositive2(),
  IsOptionalNonNullable()
], LicenseOverridesDto.prototype, "concurrency", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsEnum6(ReplayTypeEnum)
], LicenseOverridesDto.prototype, "replay", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsBoolean5()
], LicenseOverridesDto.prototype, "isGivenEventAccess", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsBoolean5()
], LicenseOverridesDto.prototype, "isGivenMarketplaceAccess", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsInt4(),
  Min5(0)
], LicenseOverridesDto.prototype, "storageInGB", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsEnum6(SupportLevelEnum)
], LicenseOverridesDto.prototype, "supportLevel", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsInt4(),
  IsPositive2(),
  Min5(1)
], LicenseOverridesDto.prototype, "storageDurationInDays", 2);
__decorateClass([
  IsOptionalNonNullable(),
  IsDateString4()
], LicenseOverridesDto.prototype, "licenseEndDate", 2);
var CreateOrganisationDto = class {
};
__decorateClass([
  IsString7(),
  IsStringNotEmpty()
], CreateOrganisationDto.prototype, "name", 2);
__decorateClass([
  IsUUID5()
], CreateOrganisationDto.prototype, "licenseId", 2);
__decorateClass([
  Type4(() => LicenseOverridesDto),
  ValidateNested3(),
  IsOptionalNonNullable()
], CreateOrganisationDto.prototype, "licenseOverrides", 2);
var UpdateOrganisationDto = class {
};
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateOrganisationDto.prototype, "name", 2);
__decorateClass([
  IsMobilePhone(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "phoneNumber", 2);
__decorateClass([
  IsUrl2(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "website", 2);
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "streetAddress", 2);
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "town", 2);
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "postcode", 2);
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "region", 2);
__decorateClass([
  IsString7(),
  IsStringNotEmpty(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "country", 2);
__decorateClass([
  IsUrl2(),
  IsOptional5()
], UpdateOrganisationDto.prototype, "logoURL", 2);
__decorateClass([
  IsEnum6(ReplayCommentStatus),
  IsOptionalNonNullable()
], UpdateOrganisationDto.prototype, "replayCommentStatus", 2);
__decorateClass([
  IsBoolean5(),
  IsOptionalNonNullable()
], UpdateOrganisationDto.prototype, "isCV1Enabled", 2);

// src/licensing/dtos.ts
var UpdateActiveLicenceDto = class {
};
__decorateClass([
  IsUUID6()
], UpdateActiveLicenceDto.prototype, "licenseId", 2);
__decorateClass([
  Type5(() => LicenseOverridesDto),
  ValidateNested4(),
  IsOptionalNonNullable()
], UpdateActiveLicenceDto.prototype, "licenseOverrides", 2);
var StartTrialDto = class {
};
__decorateClass([
  IsDateString5()
], StartTrialDto.prototype, "startDate", 2);
__decorateClass([
  IsDateString5()
], StartTrialDto.prototype, "endDate", 2);
__decorateClass([
  IsEnum7(TrialFeature)
], StartTrialDto.prototype, "feature", 2);
__decorateClass([
  IsEnum7(ReplayTypeEnum),
  IsOptionalNonNullable()
], StartTrialDto.prototype, "replayVersion", 2);

// src/licensing/organisation-trials/organisation-trials.type.ts
var PublicOrganisationTrial = class {
};

// src/playlists/dtos.ts
import { IsBoolean as IsBoolean6, IsString as IsString8, IsUUID as IsUUID7 } from "class-validator";
var CreatePlaylistDto = class {
};
__decorateClass([
  IsString8(),
  IsStringNotEmpty()
], CreatePlaylistDto.prototype, "name", 2);
__decorateClass([
  IsBoolean6()
], CreatePlaylistDto.prototype, "isPublic", 2);
var AddRecordingToPlaylistDto = class {
};
__decorateClass([
  IsUUID7()
], AddRecordingToPlaylistDto.prototype, "recordingId", 2);

// src/recordings/dtos.ts
import { Type as Type6 } from "class-transformer";
import {
  IsArray as IsArray5,
  IsDateString as IsDateString6,
  IsInt as IsInt5,
  IsNumber as IsNumber3,
  IsOptional as IsOptional6,
  IsString as IsString9,
  IsUUID as IsUUID8,
  Min as Min6,
  ValidateNested as ValidateNested5
} from "class-validator";
var CreateRecordingDto = class {
};
__decorateClass([
  IsUUID8()
], CreateRecordingDto.prototype, "sessionId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "name", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "hostName", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "duration", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "videoURL", 2);
__decorateClass([
  IsString9()
], CreateRecordingDto.prototype, "imageURL", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "organisationId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], CreateRecordingDto.prototype, "replayId", 2);
__decorateClass([
  IsInt5(),
  Min6(0)
], CreateRecordingDto.prototype, "size", 2);
var TransferRecordingDto = class {
};
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "fileUrl", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "fileName", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "orgId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "sessionId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "conferenceID", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "hostName", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "duration", 2);
__decorateClass([
  IsInt5()
], TransferRecordingDto.prototype, "numOfRetries", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "organisationId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], TransferRecordingDto.prototype, "replayId", 2);
var GetRecordingsDto = class {
};
__decorateClass([
  IsOptional6(),
  Type6(() => Number),
  IsInt5(),
  Min6(1)
], GetRecordingsDto.prototype, "limit", 2);
__decorateClass([
  IsOptional6(),
  Type6(() => Number),
  IsInt5(),
  Min6(0)
], GetRecordingsDto.prototype, "offset", 2);
__decorateClass([
  IsOptional6(),
  IsString9()
], GetRecordingsDto.prototype, "search", 2);
__decorateClass([
  IsOptional6(),
  IsString9()
], GetRecordingsDto.prototype, "sessionId", 2);
__decorateClass([
  IsOptional6(),
  IsDateString6()
], GetRecordingsDto.prototype, "startDate", 2);
__decorateClass([
  IsOptional6(),
  IsDateString6()
], GetRecordingsDto.prototype, "endDate", 2);
__decorateClass([
  IsOptional6(),
  IsString9({ each: true })
], GetRecordingsDto.prototype, "tags", 2);
var RecordingChapterDto = class {
};
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], RecordingChapterDto.prototype, "title", 2);
__decorateClass([
  IsNumber3()
], RecordingChapterDto.prototype, "start", 2);
var UpdateRecordingDto = class {
};
__decorateClass([
  IsString9(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRecordingDto.prototype, "name", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRecordingDto.prototype, "imageURL", 2);
__decorateClass([
  IsOptional6(),
  IsString9(),
  IsStringNotEmpty()
], UpdateRecordingDto.prototype, "summary", 2);
__decorateClass([
  IsOptional6(),
  IsArray5(),
  ValidateNested5({ each: true }),
  Type6(() => RecordingChapterDto)
], UpdateRecordingDto.prototype, "chapters", 2);
var GenerateThumbnailDto = class {
};
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], GenerateThumbnailDto.prototype, "recordingId", 2);
__decorateClass([
  IsString9(),
  IsStringNotEmpty()
], GenerateThumbnailDto.prototype, "timestamp", 2);

// src/recordings/recording-comment/dtos.ts
import { IsString as IsString10, IsUUID as IsUUID9 } from "class-validator";
var CreateRecordingCommentDto = class {
};
__decorateClass([
  IsUUID9(),
  IsOptionalNonNullable()
], CreateRecordingCommentDto.prototype, "parentCommentId", 2);
__decorateClass([
  IsString10(),
  IsStringNotEmpty()
], CreateRecordingCommentDto.prototype, "content", 2);
var UpdateRecordingCommentDto = class {
};
__decorateClass([
  IsString10(),
  IsStringNotEmpty()
], UpdateRecordingCommentDto.prototype, "content", 2);

// src/recordings/recording-comment/recording-comment.type.ts
var PublicRecordingComment = class {
};

// src/recordings/recording.type.ts
var PublicRecording = class {
};

// src/room-systems/dtos.ts
import { IsEmail as IsEmail3, IsEnum as IsEnum8, IsString as IsString11 } from "class-validator";

// src/room-systems/room-system.type.ts
var RoomSystemVisibility = /* @__PURE__ */ ((RoomSystemVisibility2) => {
  RoomSystemVisibility2["PUBLIC"] = "PUBLIC";
  RoomSystemVisibility2["PRIVATE"] = "PRIVATE";
  return RoomSystemVisibility2;
})(RoomSystemVisibility || {});
var RoomSystemType = /* @__PURE__ */ ((RoomSystemType2) => {
  RoomSystemType2["MINI"] = "MINI";
  RoomSystemType2["CLASSIC"] = "CLASSIC";
  RoomSystemType2["ULTRA"] = "ULTRA";
  RoomSystemType2["ULTRA_XR"] = "ULTRA_XR";
  return RoomSystemType2;
})(RoomSystemType || {});
var RoomSystemSessions = class {
};

// src/room-systems/dtos.ts
var CreateRoomSystemDto = class {
};
__decorateClass([
  IsString11(),
  IsStringNotEmpty()
], CreateRoomSystemDto.prototype, "name", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty()
], CreateRoomSystemDto.prototype, "displayName", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty()
], CreateRoomSystemDto.prototype, "extension", 2);
__decorateClass([
  IsEmail3()
], CreateRoomSystemDto.prototype, "email", 2);
__decorateClass([
  IsEnum8(RoomSystemVisibility)
], CreateRoomSystemDto.prototype, "visibility", 2);
__decorateClass([
  IsEnum8(RoomSystemType)
], CreateRoomSystemDto.prototype, "type", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty()
], CreateRoomSystemDto.prototype, "password", 2);
var UpdateRoomSystemDto = class {
};
__decorateClass([
  IsString11(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "displayName", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "extension", 2);
__decorateClass([
  IsEmail3(),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "email", 2);
__decorateClass([
  IsEnum8(RoomSystemVisibility),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "visibility", 2);
__decorateClass([
  IsEnum8(RoomSystemType),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "type", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRoomSystemDto.prototype, "password", 2);
var UpdateRoomSystemAsAdminDto = class {
};
__decorateClass([
  IsEmail3(),
  IsOptionalNonNullable()
], UpdateRoomSystemAsAdminDto.prototype, "email", 2);
__decorateClass([
  IsEnum8(RoomSystemVisibility),
  IsOptionalNonNullable()
], UpdateRoomSystemAsAdminDto.prototype, "visibility", 2);
__decorateClass([
  IsString11(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateRoomSystemAsAdminDto.prototype, "displayName", 2);

// src/rooms/rooms.type.ts
var RoomTypeEnum = /* @__PURE__ */ ((RoomTypeEnum2) => {
  RoomTypeEnum2["MEETING"] = "MEETING";
  RoomTypeEnum2["HUB"] = "HUB";
  return RoomTypeEnum2;
})(RoomTypeEnum || {});
var PublicRoom = class {
};

// src/sessions/dtos.ts
import { Type as Type7 } from "class-transformer";
import {
  IsArray as IsArray6,
  IsBoolean as IsBoolean7,
  IsDateString as IsDateString7,
  IsDefined as IsDefined3,
  IsEnum as IsEnum9,
  IsInt as IsInt6,
  IsNotEmpty as IsNotEmpty2,
  IsNumber as IsNumber4,
  IsOptional as IsOptional7,
  IsString as IsString12,
  IsUUID as IsUUID10,
  Matches as Matches2,
  Max,
  Min as Min7,
  Validate as Validate3,
  ValidateNested as ValidateNested6
} from "class-validator";
var CreateSessionDto = class {
};
__decorateClass([
  IsNotEmpty2(),
  IsDateString7(),
  Validate3(IsBeforeConstraint, ["end"]),
  Validate3(IsBeforeConstraint, ["endDateRecurring"])
], CreateSessionDto.prototype, "start", 2);
__decorateClass([
  IsNotEmpty2(),
  IsDateString7()
], CreateSessionDto.prototype, "end", 2);
__decorateClass([
  IsString12(),
  IsStringNotEmpty()
], CreateSessionDto.prototype, "name", 2);
__decorateClass([
  IsStringNotEmpty(),
  IsOptional7()
], CreateSessionDto.prototype, "description", 2);
__decorateClass([
  IsArray6(),
  Validate3(IsEmailArrayConstraint)
], CreateSessionDto.prototype, "guests", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isScheduledToRecord", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isPrivate", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isParticipantScreenSharing", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isClosedCaptionsEnabled", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isConfidential", 2);
__decorateClass([
  IsArray6(),
  IsUUID10(void 0, { each: true }),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "roomSystemIds", 2);
__decorateClass([
  IsArray6(),
  IsUUID10(void 0, { each: true }),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "organisationIds", 2);
__decorateClass([
  IsArray6(),
  IsString12({ each: true }),
  Matches2(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, {
    each: true
  }),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "moderatorIds", 2);
__decorateClass([
  IsNotEmpty2(),
  IsDateString7(),
  IsValidRecurrenceRange(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "endDateRecurring", 2);
__decorateClass([
  IsNumber4(),
  IsOptionalNonNullable(),
  Min7(1),
  Max(1e3, {
    message: "A session cannot repeat more than 1000 times, please create another session"
  })
], CreateSessionDto.prototype, "nbRepetitions", 2);
__decorateClass([
  IsDefined3(),
  IsEnum9(RecurringFrequency),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "recurringFrequency", 2);
__decorateClass([
  IsDefined3(),
  IsEnum9(RecurringEndType),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "recurringEndType", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isRaisedHandSoundEnabled", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "isChatEnabled", 2);
__decorateClass([
  IsString12(),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "parentSessionId", 2);
/**
 * Specifies every n weeks for weekly recurrence
 * Only used when recurringFrequency is WEEKLY
 */
__decorateClass([
  IsNumber4(),
  IsOptionalNonNullable(),
  Min7(1),
  Max(52, {
    message: "Weekly interval cannot exceed 52 weeks"
  })
], CreateSessionDto.prototype, "weeklyInterval", 2);
/**
 * Specifies which days of the week for weekly recurrence
 * Only used when recurringFrequency is WEEKLY
 */
__decorateClass([
  IsArray6(),
  IsEnum9(WeekDay, { each: true }),
  IsOptionalNonNullable()
], CreateSessionDto.prototype, "weeklyDays", 2);
var UpdateSessionDto = class {
};
__decorateClass([
  IsNotEmpty2(),
  IsDateString7(),
  Validate3(IsBeforeConstraint, ["end"]),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "start", 2);
__decorateClass([
  IsNotEmpty2(),
  IsDateString7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "end", 2);
__decorateClass([
  IsString12(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "name", 2);
__decorateClass([
  IsString12(),
  IsOptional7()
], UpdateSessionDto.prototype, "description", 2);
__decorateClass([
  IsArray6(),
  Validate3(IsEmailArrayConstraint),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "guests", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isScheduledToRecord", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isPrivate", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isParticipantScreenSharing", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isClosedCaptionsEnabled", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isConfidential", 2);
__decorateClass([
  IsArray6(),
  IsUUID10(void 0, { each: true }),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "roomSystemIds", 2);
__decorateClass([
  IsArray6(),
  IsString12({ each: true }),
  Matches2(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, {
    each: true
  }),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "moderatorIds", 2);
__decorateClass([
  IsArray6(),
  IsUUID10(void 0, { each: true }),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "organisationIds", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isAcceptingInvite", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isRaisedHandSoundEnabled", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateSessionDto.prototype, "isChatEnabled", 2);
var UpdateRecurringSessionDto = class extends UpdateSessionDto {
};
__decorateClass([
  IsBoolean7()
], UpdateRecurringSessionDto.prototype, "isApplyingToAll", 2);
__decorateClass([
  IsUUID10()
], UpdateRecurringSessionDto.prototype, "recurringId", 2);
__decorateClass([
  IsBoolean7()
], UpdateRecurringSessionDto.prototype, "isDisablingEmails", 2);
__decorateClass([
  IsNotEmpty2(),
  IsDateString7(),
  IsOptionalNonNullable()
], UpdateRecurringSessionDto.prototype, "endDateRecurring", 2);
__decorateClass([
  IsNumber4(),
  IsOptionalNonNullable(),
  Min7(1),
  Max(1e3, {
    message: "A session cannot repeat more than 1000 times, please create another session"
  })
], UpdateRecurringSessionDto.prototype, "nbRepetitions", 2);
__decorateClass([
  IsDefined3(),
  IsEnum9(RecurringFrequency),
  IsOptionalNonNullable()
], UpdateRecurringSessionDto.prototype, "recurringFrequency", 2);
__decorateClass([
  IsDefined3(),
  IsEnum9(RecurringEndType),
  IsOptionalNonNullable()
], UpdateRecurringSessionDto.prototype, "recurringEndType", 2);
/**
 * Specifies every n weeks for weekly recurrence
 * Only used when recurringFrequency is WEEKLY
 */
__decorateClass([
  IsNumber4(),
  IsOptionalNonNullable(),
  Min7(1),
  Max(52, {
    message: "Weekly interval cannot exceed 52 weeks"
  })
], UpdateRecurringSessionDto.prototype, "weeklyInterval", 2);
/**
 * Specifies which days of the week for weekly recurrence
 * Only used when recurringFrequency is WEEKLY
 */
__decorateClass([
  IsArray6(),
  IsEnum9(WeekDay, { each: true }),
  IsOptionalNonNullable()
], UpdateRecurringSessionDto.prototype, "weeklyDays", 2);
var GetPendingSessionsQuery = class {
};
__decorateClass([
  IsDefined3(),
  IsDateString7()
], GetPendingSessionsQuery.prototype, "startDate", 2);
__decorateClass([
  IsInt6(),
  Min7(1),
  Type7(() => Number),
  IsOptionalNonNullable()
], GetPendingSessionsQuery.prototype, "limit", 2);
__decorateClass([
  IsInt6(),
  Min7(0),
  Type7(() => Number),
  IsOptionalNonNullable()
], GetPendingSessionsQuery.prototype, "offset", 2);
__decorateClass([
  IsString12(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], GetPendingSessionsQuery.prototype, "search", 2);
var UpdateVidyoParticipantDto = class {
};
__decorateClass([
  IsString12(),
  IsNotEmpty2(),
  IsOptionalNonNullable()
], UpdateVidyoParticipantDto.prototype, "entityId", 2);
/**
 * This is the vidyo participant ID, not the
 * users db ID
 */
__decorateClass([
  IsString12(),
  IsNotEmpty2(),
  IsOptionalNonNullable()
], UpdateVidyoParticipantDto.prototype, "participantId", 2);
__decorateClass([
  IsBoolean7(),
  IsOptionalNonNullable()
], UpdateVidyoParticipantDto.prototype, "isApplyingActionToAll", 2);
var ExtendSessionDto = class {
};
__decorateClass([
  IsNumber4(),
  IsNotEmpty2()
], ExtendSessionDto.prototype, "extensionInMinutes", 2);
var SessionsStartingNowDto = class {
};
var BreakoutSessionParticipantDto = class {
};
/**
 * Vidyo participant ID, unique in every call
 */
__decorateClass([
  IsString12(),
  IsNotEmpty2()
], BreakoutSessionParticipantDto.prototype, "participantId", 2);
/**
 * Entity ID, used for room systems.
 * If the participant is a user, this is '0'
 */
__decorateClass([
  IsString12(),
  IsNotEmpty2()
], BreakoutSessionParticipantDto.prototype, "entityId", 2);
var CreateBreakoutSessionDto = class {
};
/**
 * Name of the breakout session
 */
__decorateClass([
  IsString12(),
  IsStringNotEmpty()
], CreateBreakoutSessionDto.prototype, "name", 2);
/**
 * Vidyo participant IDs
 */
__decorateClass([
  IsArray6(),
  ValidateNested6(),
  Type7(() => BreakoutSessionParticipantDto)
], CreateBreakoutSessionDto.prototype, "participants", 2);
var CreateBreakoutSessionsDto = class {
};
/**
 * Breakout session length in minutes
 */
__decorateClass([
  IsNumber4(),
  IsOptionalNonNullable(),
  Min7(1, { message: "Timer must be at least 1 minute" })
], CreateBreakoutSessionsDto.prototype, "timer", 2);
__decorateClass([
  IsArray6(),
  ValidateNested6(),
  Type7(() => CreateBreakoutSessionDto)
], CreateBreakoutSessionsDto.prototype, "rooms", 2);
var UpdateBreakoutParticipantDto = class {
};
__decorateClass([
  IsString12(),
  IsNotEmpty2()
], UpdateBreakoutParticipantDto.prototype, "participantId", 2);
/**
 * This is '0' if the participant is a user,
 * otherwise it is the entity ID of the breakout room
 */
__decorateClass([
  IsString12(),
  IsNotEmpty2()
], UpdateBreakoutParticipantDto.prototype, "entityId", 2);
var MoveBreakoutParticipantDto = class extends UpdateBreakoutParticipantDto {
};
/**
 * The ID of the breakout session to move the participant to
 */
__decorateClass([
  IsString12(),
  IsNotEmpty2()
], MoveBreakoutParticipantDto.prototype, "targetSessionId", 2);

// src/sessions/guest.type.ts
var GuestType = /* @__PURE__ */ ((GuestType2) => {
  GuestType2["Guest"] = "guest";
  GuestType2["User"] = "user";
  return GuestType2;
})(GuestType || {});

// src/sessions/recurring-session-conflict-error.ts
var RecurringSessionConflictError = class extends Error {
  constructor(statusCode = 409, message = "There is not session scheduled for today", recurringSessions) {
    super(message);
    this.statusCode = statusCode;
    this.message = message;
    this.recurringSessions = recurringSessions;
    this.name = "RecurringSessionConflictError";
  }
};

// src/sessions/session-conflict-error.ts
var SessionConflictError = class extends Error {
  constructor(statusCode = 409, message = "Session conflicts detected", conflictingSessions) {
    super(message);
    this.statusCode = statusCode;
    this.message = message;
    this.conflictingSessions = conflictingSessions;
    this.name = "SessionConflictError";
  }
};

// src/shared-recordings/dto.ts
import { IsEnum as IsEnum10, IsUUID as IsUUID11 } from "class-validator";
var ExpirationPeriod = /* @__PURE__ */ ((ExpirationPeriod2) => {
  ExpirationPeriod2["ONE_DAY"] = "ONE_DAY";
  ExpirationPeriod2["SEVEN_DAYS"] = "SEVEN_DAYS";
  ExpirationPeriod2["FOURTEEN_DAYS"] = "FOURTEEN_DAYS";
  ExpirationPeriod2["THIRTY_DAYS"] = "THIRTY_DAYS";
  return ExpirationPeriod2;
})(ExpirationPeriod || {});
var CreateSharedRecordingDto = class {
};
__decorateClass([
  IsUUID11()
], CreateSharedRecordingDto.prototype, "recordingId", 2);
__decorateClass([
  IsEnum10(ExpirationPeriod)
], CreateSharedRecordingDto.prototype, "expiresAt", 2);

// src/shared-recordings/shared-recording.type.ts
var PublicSharedRecording = class {
};

// src/sockets/sockets.type.ts
var BreakoutSessionClosedReason = /* @__PURE__ */ ((BreakoutSessionClosedReason2) => {
  BreakoutSessionClosedReason2["BREAKOUT_SESSION_CLOSED"] = "breakout-session-closed";
  BreakoutSessionClosedReason2["BREAKOUT_SESSION_TIMEOUT"] = "breakout-session-timeout";
  BreakoutSessionClosedReason2["KICK_FROM_BREAKOUT_SESSION"] = "kick-from-breakout-session";
  return BreakoutSessionClosedReason2;
})(BreakoutSessionClosedReason || {});

// src/tags/dto.ts
import { IsOptional as IsOptional8, IsString as IsString13, IsUUID as IsUUID12 } from "class-validator";
var CreateTagDto = class {
};
__decorateClass([
  IsString13(),
  IsOptional8()
], CreateTagDto.prototype, "name", 2);
__decorateClass([
  IsUUID12(),
  IsOptionalNonNullable()
], CreateTagDto.prototype, "tagId", 2);

// src/user-session-events/user-session-events.type.ts
var CreateSessionEventDto = class {
};
var UpdateSessionEventDto = class {
};

// src/users/dtos.ts
import {
  ArrayNotEmpty as ArrayNotEmpty2,
  IsArray as IsArray7,
  IsBoolean as IsBoolean8,
  IsDefined as IsDefined4,
  IsEmail as IsEmail4,
  IsIn as IsIn2,
  IsNotEmpty as IsNotEmpty3,
  IsOptional as IsOptional9,
  IsString as IsString14,
  IsTimeZone
} from "class-validator";
var CreateUserDto = class {
};
__decorateClass([
  IsEmail4()
], CreateUserDto.prototype, "email", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateUserDto.prototype, "firstName", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateUserDto.prototype, "lastName", 2);
__decorateClass([
  IsBoolean8()
], CreateUserDto.prototype, "hasAcceptedTerms", 2);
__decorateClass([
  IsBoolean8()
], CreateUserDto.prototype, "isSubscribedToMarketing", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateUserDto.prototype, "id", 2);
__decorateClass([
  IsArray7(),
  ArrayNotEmpty2()
], CreateUserDto.prototype, "organisations", 2);
__decorateClass([
  IsString14(),
  IsNotEmpty3(),
  IsOptional9()
], CreateUserDto.prototype, "invitationId", 2);
var UpdateUserDto = class {
};
__decorateClass([
  IsEmail4(),
  IsOptionalNonNullable()
], UpdateUserDto.prototype, "email", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateUserDto.prototype, "firstName", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty(),
  IsOptionalNonNullable()
], UpdateUserDto.prototype, "lastName", 2);
__decorateClass([
  IsBoolean8(),
  IsOptionalNonNullable()
], UpdateUserDto.prototype, "hasAcceptedTerms", 2);
__decorateClass([
  IsBoolean8(),
  IsOptionalNonNullable()
], UpdateUserDto.prototype, "isSubscribedToMarketing", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty(),
  IsOptional9()
], UpdateUserDto.prototype, "avatarURL", 2);
__decorateClass([
  IsTimeZone(),
  IsOptional9()
], UpdateUserDto.prototype, "timeZone", 2);
var CreateCognitoUserDto = class {
};
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateCognitoUserDto.prototype, "firstName", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateCognitoUserDto.prototype, "lastName", 2);
__decorateClass([
  IsEmail4()
], CreateCognitoUserDto.prototype, "email", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateCognitoUserDto.prototype, "password", 2);
__decorateClass([
  IsString14(),
  IsStringNotEmpty()
], CreateCognitoUserDto.prototype, "userId", 2);
var UpdateUserPermissionsDto = class {
};
__decorateClass([
  IsDefined4(),
  IsIn2(validRoleGroups)
], UpdateUserPermissionsDto.prototype, "roleGroup", 2);
__decorateClass([
  IsArray7(),
  IsIn2(validRoles, { each: true }),
  IsOptionalNonNullable()
], UpdateUserPermissionsDto.prototype, "permissions", 2);

// src/users/user.type.ts
var PublicUser = class {
};
var Me = class {
};
var CLASSVIEW_ADMINS = {
  dev: ["oscar@gearedapp.co.uk", "david.landori@gearedapp.co.uk"],
  stag: ["oscar@gearedapp.co.uk", "david.landori@gearedapp.co.uk"],
  prod: [
    "oscar@gearedapp.co.uk",
    "shafiq@i-immersive.co.uk",
    "greg@i-immersive.co.uk",
    "john@i-immersive.co.uk",
    "david.landori@gearedapp.co.uk"
  ]
};
export {
  AddEventParticipantDto,
  AddEventParticipantsDto,
  AddEventParticipantsParamsDto,
  AddOrganisationToEventDto,
  AddRecordingToPlaylistDto,
  AdditionalPermittedPermissionsByRoleGroup,
  AnnouncementType,
  Attachment,
  BreakoutSessionClosedReason,
  CLASSVIEW_ADMINS,
  CanAddToPlaylist,
  CanManageEventCategories,
  CanManageRoomSystems,
  CanManageTags,
  CanViewRecordings,
  CreateAnnouncementDto,
  CreateBreakoutSessionsDto,
  CreateCognitoUserDto,
  CreateEventCategoryDto,
  CreateEventDto,
  CreateInvitationsDto,
  CreateLicenseDto,
  CreateOrganisationDto,
  CreatePlaylistDto,
  CreateRecordingCommentDto,
  CreateRecordingDto,
  CreateRoomSystemDto,
  CreateSessionDto,
  CreateSessionEventDto,
  CreateSharedRecordingDto,
  CreateTagDto,
  CreateUserDto,
  DefaultEmailPayload,
  DefaultRoleGroupsToPermissions,
  EmailPayload,
  EmailTemplateEnum,
  EmailTemplatesToNames,
  Environments,
  EventCategory,
  EventStatus,
  EventType,
  EventVisibility,
  ExpirationPeriod,
  ExtendSessionDto,
  FeedbackRatings,
  GenerateThumbnailDto,
  GetAnalyticsDto,
  GetBaseAnalyticsDto,
  GetEventsDto,
  GetPendingSessionsQuery,
  GetRecordingsDto,
  GetReplayBaseAnalyticsDto,
  GuestType,
  HelloType,
  InviteStatusEnum,
  IsAssociatedEmailPayload,
  IsBefore,
  IsBeforeConstraint,
  IsDateAfter,
  IsEmailArrayConstraint,
  IsOptionalNonNullable,
  IsStringNotEmpty,
  IsStringNotEmptyConstraint,
  IsValidRecurrenceRange,
  LicenseOverridesDto,
  LicensingNameEnum,
  Me,
  MoveBreakoutParticipantDto,
  PublicBreakoutSession,
  PublicInvitation,
  PublicLicense,
  PublicOrganisation,
  PublicOrganisationLicense,
  PublicOrganisationTrial,
  PublicRecording,
  PublicRecordingComment,
  PublicRoom,
  PublicSession,
  PublicSessionWithHostOrganisation,
  PublicSharedRecording,
  PublicUser,
  RawEmailPayload,
  RecordUserDailyVisitsDto,
  RecordingChapterDto,
  RecurringEndType,
  RecurringFrequency,
  RecurringSessionConflictError,
  ReplayCommentStatus,
  ReplayTypeEnum,
  RoleEnum,
  RoleGroupEnum,
  RoomSystemSessions,
  RoomSystemType,
  RoomSystemVisibility,
  RoomTypeEnum,
  SESSION_FREQUENCY_MAP,
  SendEmailDto,
  SessionByRoomKey,
  SessionConflictError,
  SessionDto,
  SessionInvitesStatus,
  SessionParticipant,
  SessionPreview,
  SessionsStartingNowDto,
  StartTrialDto,
  SubmitEventInterestDto,
  SubmitFeedbackDto,
  SupportLevelEnum,
  TrackRecordingViewDto,
  TransferRecordingDto,
  TrialFeature,
  UpdateActiveLicenceDto,
  UpdateAnnouncementDto,
  UpdateBreakoutParticipantDto,
  UpdateEventDto,
  UpdateEventSessionDto,
  UpdateOrganisationDto,
  UpdateRecordingCommentDto,
  UpdateRecordingDto,
  UpdateRecurringSessionDto,
  UpdateRoomSystemAsAdminDto,
  UpdateRoomSystemDto,
  UpdateSessionDto,
  UpdateSessionEventDto,
  UpdateUserDto,
  UpdateUserPermissionsDto,
  UpdateVidyoParticipantDto,
  VidyoSessionParticipant,
  WeekDay,
  WithPagination,
  emailTemplateIdsToPayloads,
  mapRecurringFrequencyToRRule,
  validRoleGroups,
  validRoles
};
